"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.wrapWithImpressionClickProps = exports.default = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread2"));

var _reactRedux = require("react-redux");

var _click = require("./click");

/**
 *
 * This is a `smart` component. It will pass along an impression info for an
 * impression of the same ID, if it has been fired
 *
 */
var wrapWithImpressionClickProps = function wrapWithImpressionClickProps(component) {
  return (0, _reactRedux.connect)(function (state, ownProps) {
    if (state.impressions && state.impressions[ownProps.id]) {
      var impression = state.impressions[ownProps.id];
      var props = (0, _objectSpread2.default)({}, ownProps);
      props.eventProps = (0, _objectSpread2.default)({
        clickHeader: impression.impressionHeader
      }, props.eventProps);
      return props;
    }

    return ownProps;
  })((0, _click.wrapWithClickProps)(component));
};

exports.wrapWithImpressionClickProps = wrapWithImpressionClickProps;

var _default = wrapWithImpressionClickProps('a');

exports.default = _default;